import Breadcrumb from "components/Common/Breadcrumb"
import moment from "moment"
import React, { useEffect, useState } from "react"
import {
  FaChevronLeft,
  FaChevronRight,
  FaPen,
  FaPlus,
  FaTrash,
  FaThumbtack,
  FaPlay,
} from "react-icons/fa6"
import { Card, CardBody, Col, Container, Input, Modal, ModalBody, ModalHeader, Row, Table } from "reactstrap"
import AddLibraryModal from "./AddLibraryModal"
import Swal from "sweetalert2"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import Loader from "components/Loader/loader"

const LibraryIndex = () => {
  const [library, setLibrary] = useState([]) // state instead of const
  const [data, setData] = useState([])
  const [page, setPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [loading, setloading] = useState(false)
  const [searchString, setSearchString] = useState("")

  useEffect(() => {
    if (searchString !== "") {
      const filteredData = data.filter(item =>
        item.title.toLowerCase().includes(searchString.toLowerCase())
      )
      setLibrary(filteredData)
      setPage(1)
    } else {
      setLibrary(data)
    }
  }, [searchString, data])

  useEffect(() => {
    getLibraryData()
  }, [])

  async function getLibraryData() {
    const APIData = await fetchData(setloading, "library")

    if (APIData?.success) {
      setLibrary(APIData?.libraries)
      setData(APIData?.libraries)
    }
  }

  const totalPages = Math.ceil(library.length / itemsPerPage)
  const finalData = library.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  )

  const changePage = pageNumber => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setPage(pageNumber)
      window.scrollTo(0, 0)
    }
  }

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingEvent, setEditingEvent] = useState(null)

  // handle Add / Edit
  const handleSave = async (entry, isEdit, editid) => {
    if (isEdit) {
      const APIData = await FetchPutData(setloading, "library", editid, entry)

      if (APIData?.data?.success) {
        Swal.fire({
          title: "Library Content Updated Successfully",
          icon: "success",
        })
        getLibraryData()
      } else {
        Swal.fire({
          title: "Something went wrong",
          icon: "error",
          description: APIData?.response?.data?.message,
        })
      }
    } else {
      const APIData = await FetchPostData(setloading, "library", entry)

      if (APIData?.data?.success) {
        Swal.fire({
          title: "Library Content Added Successfully",
          icon: "success",
        })
        getLibraryData()
      } else {
        Swal.fire({
          title: "Something went wrong",
          icon: "error",
          description: APIData?.response?.data?.message,
        })
      }
    }
  }

  const handleDelete = userId => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete this Library Item.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIData = await FetchDeleteData(setloading, "library", userId)

        if (APIData?.data?.success) {
          Swal.fire({
            title: "Library Content Deleted Successfully",
            icon: "success",
          })
          getLibraryData()
        } else {
          Swal.fire({
            title: "Something went wrong",
            icon: "error",
            description: APIData?.response?.data?.message,
          })
        }
      }
    })
  }

  const [videoModalOpen, setVideoModalOpen] = useState(false)
  const [videoId, setVideoId] = useState(null)

  const handleVideoOpen = url => {
    // Extract YouTube video ID
    const match = url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^?&]+)/
    )
    if (match) {
      setVideoId(match[1])
      setVideoModalOpen(true)
    } else {
      Swal.fire("Invalid YouTube URL", "", "error")
    }
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid>
        <Breadcrumb title="" breadcrumbItem="Workouts" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="text-black fw-bold ps-1 mb-0">Library</h4>
                  <div className="d-flex gap-3">
                    <div className="form-group">
                      <Input
                        placeholder="Search Library Items"
                        value={searchString}
                        onChange={e => setSearchString(e.target.value)}
                      />
                    </div>
                    <button
                      className="btn btn-add"
                      onClick={() => {
                        setEditingEvent(null)
                        setIsModalOpen(true)
                      }}
                    >
                      <FaPlus className="me-1" size={14} />
                      Add Library Item
                    </button>
                  </div>
                </div>

                <div className="mt-3">
                  <Table responsive bordered className="rounded-3">
                    <thead className="table-primary text-dark">
                      <tr>
                        <th>Sr No.</th>
                        <th>Title</th>
                        <th>Publish Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {finalData
                        .sort((a, b) => (b.type ? 1 : 0) - (a.type ? 1 : 0))
                        .map((user, index) => (
                          <tr
                            key={user.id}
                            style={{
                              backgroundColor: user?.type && "#fff3cd",
                            }}
                          >
                            <td>{(page - 1) * itemsPerPage + index + 1}</td>
                            <td
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              {(() => {
                                if (user?.ytlink) {
                                  // ✅ Handle YouTube link
                                  // Extract video ID (supports full & short URLs)
                                  const videoIdMatch = user.ytlink.match(
                                    /(?:youtube\.com\/(?:.*v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
                                  )
                                  const videoId = videoIdMatch
                                    ? videoIdMatch[1]
                                    : null
                                  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`

                                  return (
                                    <div
                                      style={{
                                        position: "relative",
                                        width: 70,
                                        height: 50,
                                        borderRadius: "10px",
                                        overflow: "hidden",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        handleVideoOpen(user.ytlink)
                                      }
                                    >
                                      <img
                                        src={thumbnailUrl}
                                        alt="YouTube Thumbnail"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                          borderRadius: "10px",
                                        }}
                                      />
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "50%",
                                          left: "50%",
                                          transform: "translate(-50%, -50%)",
                                          background: "rgba(0,0,0,0.6)",
                                          borderRadius: "50%",
                                          width: 70,
                                          height: 50,
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <FaPlay color="#fff" size={12} />
                                      </div>
                                    </div>
                                  )
                                } else if (user?.media) {
                                  // ✅ Handle uploaded media
                                  const fileUrl = `${process.env.REACT_APP_IMAGE_PATH}${user?.media}`
                                  const fileExtension = user?.media
                                    ?.split(".")
                                    .pop()
                                    ?.toLowerCase()

                                  if (
                                    [
                                      "mp4",
                                      "webm",
                                      "ogg",
                                      "mov",
                                      "mkv",
                                    ].includes(fileExtension)
                                  ) {
                                    const handleVideoClick = e => {
                                      const video = e.currentTarget
                                      if (video.requestFullscreen)
                                        video.requestFullscreen()
                                      else if (video.webkitRequestFullscreen)
                                        video.webkitRequestFullscreen()
                                      else if (video.msRequestFullscreen)
                                        video.msRequestFullscreen()
                                      video.play()
                                    }

                                    return (
                                      <video
                                        width={70}
                                        height={50}
                                        muted
                                        playsInline
                                        onClick={handleVideoClick}
                                        style={{
                                          borderRadius: "10px",
                                          objectFit: "cover",
                                          backgroundColor: "#000",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <source
                                          src={fileUrl}
                                          type={`video/${fileExtension}`}
                                        />
                                      </video>
                                    )
                                  } else {
                                    return (
                                      <img
                                        src={fileUrl}
                                        width={70}
                                        height={50}
                                        style={{
                                          borderRadius: "10px",
                                          objectFit: "cover",
                                          backgroundColor: "#f2f2f2",
                                        }}
                                        alt="library media"
                                      />
                                    )
                                  }
                                } else {
                                  return (
                                    <div
                                      style={{ width: 50, height: 50 }}
                                    ></div>
                                  )
                                }
                              })()}

                              {user?.title}
                              <div>
                                {user?.type && (
                                  <FaThumbtack
                                    color="#ff8c00"
                                    size={16}
                                    className="me-3"
                                  />
                                )}
                              </div>
                            </td>

                            <td>
                              {moment(user?.publishDate).format("DD-MM-YYYY")}
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-primary me-2"
                                onClick={() => {
                                  setEditingEvent(user)
                                  setIsModalOpen(true)
                                }}
                              >
                                <FaPen size={12} />
                              </button>
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => handleDelete(user?._id)}
                              >
                                <FaTrash size={12} />
                              </button>
                            </td>
                          </tr>
                        ))}
                      {finalData.length === 0 && (
                        <tr>
                          <td colSpan={4} className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                <div className="d-flex justify-content-between align-items-center my-2 px-2">
                  <p className="mb-0">
                    Showing {finalData.length} out of {library.length} Workouts.
                  </p>
                  <div className="d-flex flex-wrap">
                    <div
                      className="bd-number-pagination me-1"
                      onClick={() => changePage(page - 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronLeft />
                    </div>
                    {[...Array(totalPages)].map((_, i) => {
                      const pageIndex = i + 1
                      return (
                        <div
                          key={pageIndex}
                          className={`bd-number-pagination me-1 ${
                            page === pageIndex ? "activepage" : ""
                          }`}
                          onClick={() => changePage(pageIndex)}
                          style={{ cursor: "pointer" }}
                        >
                          {pageIndex < 10 ? "0" + pageIndex : pageIndex}
                        </div>
                      )
                    })}
                    <div
                      className="bd-number-pagination"
                      onClick={() => changePage(page + 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronRight />
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <AddLibraryModal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
        onSave={handleSave}
        editData={editingEvent}
        libraryData={library}
      />
      <Modal
        isOpen={videoModalOpen}
        toggle={() => setVideoModalOpen(!videoModalOpen)}
        size="lg"
        centered
      >
        <ModalHeader toggle={() => setVideoModalOpen(!videoModalOpen)}>
          Video Preview
        </ModalHeader>
        <ModalBody className="text-center">
          {videoId ? (
            <iframe
              width="100%"
              height="400"
              src={`https://www.youtube.com/embed/${videoId}`}
              frameBorder="0"
              allowFullScreen
              title="YouTube Video"
            ></iframe>
          ) : (
            <video
              width="100%"
              height="400"
              controls
              src={videoId}
              style={{ borderRadius: "10px" }}
            />
          )}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default LibraryIndex
